// 【Vue.js】Web API通信のデザインパターン (個人的ベストプラクティス) - Qiita https://camo.qiitausercontent.com/57501ca78cedc3fb8a08eae21dcc8f6f196f6a9a/68747470733a2f2f71696974612d696d6167652d73746f72652e73332e61702d6e6f727468656173742d312e616d617a6f6e6177732e636f6d2f302f3134393231322f62326365356234312d343566612d346463372d666562662d6439623038343131386135642e706e67
import Repository from './Repository';
import { NSNews } from '@/types/News';

// https://github.com/axios/axios/issues/1510

interface ServerData {
  posts: NSNews.Posts;
}

export interface PostsRepositoryServerResponse {
  data: ServerData;
}

// 実際に利用するときは、StoreのNewsのStateに「Endpoint」とかいうのを初期化時に配置する
export default {
  async get(resource: string) {
    console.log(resource);
    return Repository.get<ServerData>(resource, {
      timeout: 1000
    });
  }
};
